// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY:CHALLENGES
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community': [],
  'templito:community/challenge': [],
  'templito:community/user_info': []
})(this, function (m_module, Backbone, $, moment, _) {
  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  M.Community.View.UserResponseWidget = Backbone.View.extend({
    template: M.Template.Community.UserResponseWidget,
    userInfoTemplate: M.Template.Community.UserInfo.UserInfoBrief,
    answeredAllPollsTemplate: M.Template.Community.Challenge.AnsweredAllPolls,

    className: 'userResponseWidget communityPage',
    events: {
      'click .secondaryActionButton': 'fetchDataAndRender',
    },
    options: {
      secondaryHeaderText: '',
    },

    initialize: function() {
      M.required(this.options.collection);
      M.required(this.options.headerText);
      M.required(this.options.challengeId);
      _.bindAll(this, '_setCurrentModelAndRender', '_renderErrorMessage',
        'fetchDataAndRender');
    },

    /**
     * The main function for initializing the state and rendering this panel.
     * First, it fetchs additional data if there isn't any.
     * Then it updates the current state of the dialog, and then renders.
     */
    fetchDataAndRender: function() {
      var that = this;
      if (this.collection.length == 0) {
        this.collection.fetch({
          data: {
            // NOTE: this assumes the challenge is always the same
            challenge_id: that.options.challengeId,
            challenge_title: that.options.challengeTitle
          },
          success: function() {
            that._setCurrentModelAndRender();
          },
          error: function() {
            // TODO: log an error message?
            that._renderErrorMessage();
          }
        });
      } else {
        this._setCurrentModelAndRender();
      }
    },

    /**
     * Helper method. It gets the next item to show, sets it as
     * the current one, and then renders the model if it exists, or renders
     * a short message otherwise.
     */
    _setCurrentModelAndRender: function() {
      this._setNextModelAsCurrent();

      if (this.currentModel) {
        // Render the outer part of the panel then
        // setup and render the main design contents separately
        this.render();
        this._setupAndRenderMainContents();
      } else {
        // If the model isn't set, then just show a message saying there are no
        // polls left
        this._renderAllPollsAnsweredMessage();
      }
    },

    /**
     * Takes the first item out of the collection and sets it as the current one
     */
    _setNextModelAsCurrent: function() {
      // The previous model will be used to show the results of the previous poll
      // after forwarding to the next one.
      this.previousModel = this.currentModel;
      this.currentModel = this.collection.shift();

      // If the next item we got off the collection is the same design as the
      // current one, then shift another one off the collection
      // TODO: this is a very limited, short term solution until we write
      // a backend solution for never returning polls the user has voted on
      if (this.previousModel && this.previousModel.get('designId') ==
          this.currentModel.get('designId')) {
        this.currentModel = this.collection.shift();
      }
    },

    render: function() {
      // Render the main template
      var templateVars = {
        headerText: this.options.headerText,
        secondaryHeaderText: this.options.secondaryHeaderText,
        buttonLabel: this.options.buttonLabel
      };
      _.extend(templateVars, this.currentModel.toJSON());
      this.$el.html(this.template(templateVars));

      // Render the user info section
      this.$el.find('.activityCalloutContainer .userInfoContainer').html(
        this.userInfoTemplate(this.currentModel.get('userInfo')));

      // Render the bottom panel if appropriate
      // TODO: we need to render the rest of the bottom panel
      // eg the designer info & the comment box
      if (this.previousModel) {
        this.$el.find('.secondaryContents').show();
        this._setupAndRenderPreviousPollResults(this.$el.find('.secondaryContents'));
      }
      return this;
    },

    /**
     * Helper method that sets up any additional models/views to render the
     * .mainContents section of this view.
     *
     * TODO: For now, this makes a call to the polls widgets to fetch and create
     * poll widgets to display as the main contents in this panel.
     * Eventually, we'll need to have this function do different setup
     * for other use cases besides poll. Maybe pass this call in as a function
     * parameter to this view?
     */
    _setupAndRenderMainContents: function() {
      this._setupPollGalleryData(this.currentModel.get('pollId'),
        this.currentModel.get('urlPaths'), this.$el.find('.mainContents'),
        true, false);
    },

    _setupAndRenderPreviousPollResults: function($container) {
      // Render the name of the design
      $container.find('.itemUrl').attr('href', this.previousModel.get('itemUrl'));
      $container.find('.itemUrl').html(this.previousModel.get('itemName'));

      // Render the user info section
      $container.find('.userInfoContainer').html(
        this.userInfoTemplate(this.previousModel.get('userInfo')));

      // Previous poll
      this._setupPollGalleryData(this.previousModel.get('pollId'),
        this.previousModel.get('urlPaths'), $container.find('.designContents'),
        false, true);

      // Render the comment box
      var communityComment = this._createCommunityComment(
        this.previousModel.get('designId'), this.previousModel.get('urlPaths'));

      this.$el.find('.secondaryContents .communityCommentContainer').append(
        communityComment.render().$el);

    },

    _setupPollGalleryData: function(pollId, pollUrlPaths, $pollContainerEl,
        hideResults, disableSelecting) {
      M.assert(pollId);
      var additionalOptions = {
        shouldHidePollOwnerControls: true,
        useMinimalOptionTemplate: true,
        hideHeader: true
      };
      additionalOptions['hideResults'] = hideResults;
      additionalOptions['disableSelecting'] = disableSelecting;

      M.View.Design.Poll.queryAndSetUpPoll(M.currentUser.uid,
        pollId, $pollContainerEl, null, pollUrlPaths, this.fetchDataAndRender,
        additionalOptions);
    },

    _renderAllPollsAnsweredMessage: function() {
      this.$el.html(this.answeredAllPollsTemplate());
    },

    _renderErrorMessage: function() {
      this.$el.html('<p class="text--light">Something went wrong while loading this artwork. ' +
        'Please try again later.</p>');
    },

    _createCommunityComment: function(designId, urlPaths) {
      var commentOptions = {
        designId: designId,
        urlPaths: urlPaths
      };
      return new M.Community.View.CommunityComment(commentOptions);
    }

  });

  return {  };

});